import { IBillingPopupModel } from "@/Billing/Models/UI/IBillingPopupModel";
import { BillingPaymentMethodsHelper } from "@/Common/Helpers/BillingPaymentMethodsHelper";
import { JSXHelper } from "@/Common/Helpers/JSXHelper";
import { PhoneType } from "@/Common/Models/Contacts/Enums/PhoneType";
import { BillingPaymentMethod } from "@/Common/Models/UI/BillingPaymentMethod";
import { PrivateBill_BilledTo } from "@/Common/Models/UI/Enums";
import * as LocalOperations from "@/Common/Operations/operations.local";

interface IBillingFormProps {
    model: IBillingPopupModel;
}

class BillingForm extends React.Component<IBillingFormProps, never> {
    private renderMidRow(key: string, value: string): JSX.Element {
        return (
            <tr>
                <td className="text-right" style={{ paddingRight: "5px" }}><label className="form-lable uppercase">{key}</label></td>
                <td><strong>{value}</strong></td>
                <td />
                <td />
            </tr>
        );
    }

    private renderLowerRow(label: string, formattedPrice: string, currency: string, percnt?: string): JSX.Element {
        var prc = percnt == null ? null : "(" + percnt + "%)";
        return (
            <tr>
                <td />
                <td className="text-right" style={{ paddingRight: "4px" }}><span>{label} {prc}</span></td>
                <td className="text-right" style={{ paddingRight: "4px" }}><strong>{formattedPrice}</strong></td>
                <td><span>{currency}</span></td>
            </tr>
        );
    }

    private getColumnWidthSpecs(): JSX.Element {
        return (
            <colgroup>
                <col style={{ width: "200px" }} />
                <col style={{ width: "350px" }} />
                <col style={{ width: "120px" }} />
                <col style={{ width: "70px" }} />
            </colgroup>
        );
    }

    public render(): JSX.Element {
        const showPaymentMethod = BillingPaymentMethodsHelper.getPaymentMethodIdWithValue(this.props.model.get("PaymentMethod")) != BillingPaymentMethod.Payable || !cacheStore.ClinicSettings.EnablePrivateBillRecipient;

        var billedService = this.props.model.get("BilledService");
        var billedServiceRender = billedService.map((service, index) => (
            <tr key={`${service.ServiceNumber} ${service.ServiceName} ${index}`}>
                <td style={{ textAlign: "right" }} />
                <td>
                    <strong>{index + 1}) {service.ServiceNumber} - {service.ServiceName}</strong>
                </td>
                <td className="text-right" style={{ paddingRight: "4px" }}>
                    <strong>{service.ServiceMultiplicator} x $ {service.ServicePrice.toFixed(2)} </strong>
                </td>
                <td>
                    <span>CAD</span>
                </td>
            </tr>
        ));

        const site = this.props.model.get("Site");
        const siteAddress = site.getFormattedAddress();
        const isBilledToThirdParty = this.props.model.get("BilledTo") === PrivateBill_BilledTo.ThirdParty;

        return (
            <div onClick={e => this.stopPropagation(e)} className="popup billing">
                <div className="p-header">
                    <div className="row">
                        <div className="col-lg-12">
                            <div className="clearfix">
                                <a className="close" onClick={e => this.closePopup(e)}>x</a>
                                <h3 className="uppercase">{cacheStore.GetString("PreviewLabel")}</h3>
                            </div>
                        </div>
                    </div>
                </div>
                <div className="row">
                    <div className="col-lg-12">
                        <div className="p-body">
                            <div className="row bottom-border-light">
                                <div className="flex-container" style={{ justifyContent: "center", paddingBottom: "5px" }}>
                                    <div className="text-center">
                                        <h4>{JSXHelper.getSiteDepartmentNameJSX(site.Model.ClinicalName, "")}</h4>
                                        <div style={{ marginTop: "5px" }}>
                                            {siteAddress}
                                        </div>
                                        <div className="prow flex-container" style={{ justifyContent: "space-evenly" }}>
                                            {site.Model.Phones && (
                                                <span>
                                                    {cacheStore.GetString("PhoneAbbrLabel")}
                                                    {site.getFormattedPhoneByType(PhoneType.Phone)}
                                                </span>
                                            )}
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div className="row bottom-border-light" style={{ paddingTop: "10px", paddingBottom: "10px", marginBottom: "10px" }}>
                                <div className="col-xs-6">
                                    {!cacheStore.ClinicSettings.EnablePrivateBillRecipient && (
                                        <div>
                                            <strong>{cacheStore.GetString("BilledToLabel")}: </strong>
                                            {this.props.model.get("PatientName")}
                                        </div>
                                    )}
                                    {cacheStore.ClinicSettings.EnablePrivateBillRecipient && (
                                        <>
                                            <div>
                                                <strong>{cacheStore.GetString("BilledToLabel")}: </strong>
                                                {isBilledToThirdParty
                                                    ? this.props.model.get("RecipientName")
                                                    : this.props.model.get("PatientName")
                                                }
                                            </div>
                                            {isBilledToThirdParty && (
                                                <div>
                                                    <strong>{cacheStore.GetString("PatientNameLabel")}: </strong>
                                                    {this.props.model.get("PatientName")}
                                                </div>
                                            )}
                                        </>
                                    )}
                                    <div>
                                        <strong>{cacheStore.GetString("HealthCard_NAM")}: </strong>
                                        {this.getPatientNam()}
                                    </div>
                                    <div>
                                        <strong>{cacheStore.GetString("DateofBirthLabel")}: </strong>
                                        {this.props.model.get("PatientDateOfBirth")}
                                    </div>
                                </div>
                                <div className="col-xs-6">
                                    <div>
                                        <strong>{cacheStore.GetString("PhoneLabel")}: </strong>
                                        {this.props.model.get("PatientPhone")}
                                    </div>
                                    <div>
                                        <strong>{cacheStore.GetString("AddressLabel")}: </strong>
                                        {this.props.model.get("PatientAddress")}
                                    </div>
                                </div>
                            </div>
                            <div className="tb-wrapper">
                                <table className="fixed-table">
                                    {this.getColumnWidthSpecs()}
                                    <tbody>
                                        {this.renderMidRow(cacheStore.GetString("InvoiceNumberLabel"), this.props.model.get("InvoiceNumber"))}
                                        {this.renderMidRow(cacheStore.GetString("DateOfVisitLabel"), this.props.model.get("DateOfVisit"))}
                                        {(this.props.model.get("ProviderName")
                                            && this.props.model.get("ProviderName") !== "--"
                                            && this.renderMidRow(cacheStore.GetString("ProviderLabel"), this.props.model.get("ProviderName")))
                                        }
                                        {showPaymentMethod && this.renderMidRow(cacheStore.GetString("PaymentMethodLabel"), this.props.model.get("PaymentMethod"))}

                                    </tbody>
                                </table>
                            </div>
                            <div className="tb-wrapper limited">
                                <table className="fixed-table">
                                    {this.getColumnWidthSpecs()}
                                    <tbody>
                                        {billedServiceRender}
                                    </tbody>
                                </table>
                            </div>
                            <div className="tb-wrapper">
                                <table className="fixed-table">
                                    {this.getColumnWidthSpecs()}
                                    <tbody>
                                        {this.renderLowerRow(cacheStore.GetString("SubtotalLabel"), "$ " + this.props.model.get("SubTotal").toFixed(2), cacheStore.defaultCurrencyUnit)}
                                        {this.renderLowerRow(cacheStore.GetString("DiscountLabel"), "- " + this.props.model.get("Discount").toFixed(2), this.props.model.get("DiscountType"))}
                                        {(site.isGst() || !!this.props.model.get("GSTTotal")) && this.renderLowerRow(cacheStore.GetString("GstMLabel"), "$ " + this.props.model.get("GSTTotal").toFixed(2), cacheStore.defaultCurrencyUnit, "" + this.props.model.get("GST"))}
                                        {(site.isPstOrQst() || !!this.props.model.get("QSTTotal")) && this.renderLowerRow(site.getPstOrQstLabel(), "$ " + this.props.model.get("QSTTotal").toFixed(2), cacheStore.defaultCurrencyUnit, "" + this.props.model.get("QST"))}
                                        {(site.isHst() || !!this.props.model.get("HSTTotal")) && this.renderLowerRow(cacheStore.GetString("HstMLabel"), "$ " + this.props.model.get("HSTTotal").toFixed(2), cacheStore.defaultCurrencyUnit, "" + this.props.model.get("HST"))}
                                        {(!site.isCanadaSite() || !!this.props.model.get("GenericTaxTotal")) && this.renderLowerRow(cacheStore.GetString("TaxLabel"), "$ " + this.props.model.get("GenericTaxTotal").toFixed(2), cacheStore.defaultCurrencyUnit, "" + this.props.model.get("GenericTax"))}
                                        {this.renderLowerRow(cacheStore.GetString("TotalLabel"), "$ " + this.props.model.get("Total").toFixed(2), cacheStore.defaultCurrencyUnit)}
                                    </tbody>
                                </table>
                            </div>
                            <div className="row">
                                <div className="col-lg-3 text-right">
                                    <label className="form-lable uppercase">{cacheStore.GetString("NotesLabel")}</label>
                                </div>
                                <div className="col-lg-9">
                                    <p><strong>{this.props.model.get("BillNote")}</strong></p>
                                </div>
                            </div>
                            <div className="row" />
                            <div className="row">
                                <div className="col-lg-7">
                                    <p><span>{this.props.model.get("BilledByName")}</span> -<span> {this.props.model.get("BilledBySpeciality")} </span><span>{cacheStore.GetString("OnLabel")}</span> <span>{this.props.model.get("DateOfVisitFooter")}</span></p>
                                </div>
                                <div className="col-lg-5 text-right">
                                    <p><strong>{cacheStore.GetString("SignatureLabel")} </strong><span>_________________________</span></p>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        );
    }

    private closePopup(e: React.MouseEvent): void {
        e.preventDefault();
        sessionStore.dispatch(LocalOperations.Billing.Transactions_Close_BillingPopup);
    }

    private stopPropagation(e: React.MouseEvent): void {
        e.stopPropagation();
    }

    private getPatientNam(): string {
        if (IsNullOrWhiteSpace(this.props.model.get("PatientNAM")))
            return "";

        return `${this.props.model.get("PatientNAM")} - ${cacheStore.GetString("ExpLabel")} ${this.props.model.get("PatientNAMExpiryDate")}`;
    }
}

export { BillingForm };
